import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormLevelLiquidationComponent } from '../form-level-liquidation/form-level-liquidation.component';


const routes: Routes = [
  {
    path: '',
    component: FormLevelLiquidationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormLevelLiquidationRoutingModule { }
